import React from 'react'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import style from './style'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useEffect } from 'react'
import axios from '../../Services/axios'
import Swal from 'sweetalert2'

export default function Conselheiro(){
    const classes = style()
    const [conselheiros, setConselheiros] = useState([])

    useEffect(() => {
        axios
            .get("conselheiro")
            .then(({data}) => {
                setConselheiros(data.data)
            })
            .catch(err => {
                console.log(err)
                Swal.fire("Falha ao carregar dados. Atualize a tela.")
            })
    }, [])

    const history = useHistory()
    return (
        <div>
            <Typography className={classes.title} variant="h1" >Cadastro de Conselheiro Tutelar</Typography>

            <div className={classes.containerButton}>
                <Button variant="contained" color="primary" onClick={() => {
                    history.push("conselheiro/cadastrar")
                }}>
                  Criar novo
                </Button>
            </div>

            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Nome</TableCell>
                            <TableCell align="center">E-mail</TableCell>
                            <TableCell align="center">CPF</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            conselheiros.map((row) => (
                                <TableRow>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>{row.cpf}</TableCell>
                                    <TableCell>
                                        <IconButton aria-label="" onClick={() => {
                                            Swal.fire({
                                                title: 'Tem certeza que deseja excluir?',
                                                text: "Você não poderá desfazer esta ação!",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Sim!'
                                            }).then((result) => {
                                                if (result.value) {
                                                    axios
                                                        .delete(`conselheiro/${row.id}`)
                                                        .then(() => {
                                                            const newConselheiros = conselheiros.filter(conselheiro => conselheiro.id !== row.id)
                                                            setConselheiros(newConselheiros)
                                                            Swal.fire(
                                                              'Excluído!',
                                                              'Registro excluído com sucesso..',
                                                              'success'
                                                            )
                                                        })
                                                        .catch(err => {
                                                            console.log(err)
                                                            Swal.fire("Falha ao excluir. Tente novamente.")
                                                        })
                                                }
                                            })
                                        }}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                        <IconButton aria-label="" onClick={() => {
                                            history.push(`/conselheiro/${row.id}/editar`)
                                        }}>
                                            <EditIcon color="action" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )) 
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}